import { handleFormError } from 'assets/js/misc';

angular.module('logbook')
.directive('scheduledShiftEditor', ['$timeout', "$http", "$location", "$window", "$q", "timeUnitService", 
function($timeout, $http, $location, $window, $q, timeUnitService) {
  return {
    restrict: 'E',

    scope: {
       selectedLog: '='
    },

	template: require('./scheduled-shift-editor.html'),

    link: function(scope, elem, attrs) {
       
       scope.refreshShifts = function()
       {
          $http.get('/api/scheduledShifts', {
             params: {
                log: scope.selectedLog.id
             }
          }).then(function(result) {
             scope.shifts = result.data._embedded.scheduledShifts;
             scope.selectedDays = {};
             scope.shifts.forEach(function(shift) {
                scope.selectedDays[shift._links.self.href] = {};
                shift.weekdays.forEach(function(weekday) {
                   scope.selectedDays[shift._links.self.href][weekday] = true;
                });
             });
          });
       };
       scope.refreshShifts();
       
       scope.resetNewShift = function()
       {
          scope.newShift = {
             log: scope.selectedLog._links.self.href
          };
          scope.newSelectedDays = {};
       };

       scope.setNewShiftField = function(field, $data) {
          scope.newShift[field] = $data;
       };
       
       timeUnitService.getWeekdays().then(function(response) {
          scope.weekdays = response.data;
       });
       
       scope.getSelectedDays = function(days)
       {
          var res = [];
          Object.keys(days).forEach(function(day) {
             if( days[day] )
                res.push(day);
          });
          return res;
       }
       
       
       scope.addShift = function()
       {
          var d = $q.defer();
          if( scope.checkNameExists(scope.newShift['name']) )
          {
             handleFormError(d, scope.newShiftForm, [{
                "property": "name",
                "message": "A shift with this name already exists."
             }]);
             return d.promise;
          }
          scope.newShift.weekdays = scope.getSelectedDays(scope.newSelectedDays);
          $http.post('/api/scheduledShifts', scope.newShift, {
             'noErrorPopup': true,
             'rawError' : true
          }).then(function() {
             d.resolve();
             scope.resetNewShift();
             scope.refreshShifts();
          }, function(errors) {
             handleFormError(d, scope.newShiftForm, errors);
          });
          return d.promise;
       };
       
       scope.deleteShift = function(shift)
       {
          $http.delete(shift._links.self.href).then(scope.refreshShifts);
       }
       
       scope.updateShiftField = function(shift, field, data)
       {
          if( data.trim && data.trim().length == 0 )
             data = null;
          if( field == 'name' && scope.checkNameExists(data))
          {
             return "A shift with this name already exists.";
          }
          var update = {};
          update[field] = data;
          var promise = $http.patch(shift._links.self.href, update);
          promise.then(scope.refreshShifts);
          return promise;
       };
       
       scope.checkNameExists = function(name) {
          return scope.shifts.filter(function(shift) {
             return name && shift.name && name.toLowerCase() == shift.name.toLowerCase();
          }).length > 0;
       }
        
       
       scope.updateDays = function(shift) {
          $http.patch(shift._links.self.href, {
             'weekdays' : scope.getSelectedDays(scope.selectedDays[shift._links.self.href])
          });
       };
       
    }
  }
}]);
